const decideSearchType = require('./searchModel/decideSearchType');
const {
    modelProperty,
    validators
} = require('gui');

module.exports = function searchModel(value) {
    var c = {};
    c.text = modelProperty(validators.alwaysTrue, value);
    c.type = modelProperty(validators.alwaysTrue, decideSearchType(value));
    c.text.subscribeChange(newValue => c.type(decideSearchType(newValue)));

    return c;
}